import { usePermissions } from '@/hooks/use-permissions';
import { CreateFolderDialog } from '@/features/workgroups/components/create-folder-dialog';
import { UploadFileDialog } from '@/features/workgroups/components/upload-file-dialog';
import { Button } from '@/components/ui/button';

interface WorkGroupBrowserToolbarProps {
  workGroupId: string;
  currentFolderId?: string;
  isRootFolder?: boolean;
  privateAccessReason?: string;
  onRenameCurrentFolder?: () => void;
  onDeleteCurrentFolder?: () => void;
  onManagePermissions?: () => void;
}

export function WorkGroupBrowserToolbar({
  workGroupId,
  currentFolderId,
  isRootFolder,
  privateAccessReason,
  onRenameCurrentFolder,
  onDeleteCurrentFolder,
  onManagePermissions,
}: WorkGroupBrowserToolbarProps) {
  const { hasCapability } = usePermissions();
  const canCreateFolder = hasCapability('workgroups.folder.create');
  const canEditFolder = hasCapability('workgroups.folder.edit');
  const canDeleteFolder = hasCapability('workgroups.folder.delete');
  const canUpload = hasCapability('workgroups.file.upload');
  const canManagePermissions = hasCapability('workgroups.folder.permissions.manage');

  return (
    <div className="flex flex-wrap items-center gap-2">
      {canCreateFolder ? (
        <CreateFolderDialog
          workGroupId={workGroupId}
          parentFolderId={currentFolderId}
          privateAccessReason={privateAccessReason}
        />
      ) : null}
      {canUpload ? (
        <UploadFileDialog
          workGroupId={workGroupId}
          folderId={currentFolderId}
          privateAccessReason={privateAccessReason}
        />
      ) : null}
      {currentFolderId && canManagePermissions && onManagePermissions ? (
        <Button variant="outline" size="sm" onClick={onManagePermissions}>
          Permissions
        </Button>
      ) : null}
      {currentFolderId && !isRootFolder && canEditFolder && onRenameCurrentFolder ? (
        <Button variant="outline" size="sm" onClick={onRenameCurrentFolder}>
          Rename folder
        </Button>
      ) : null}
      {currentFolderId && !isRootFolder && canDeleteFolder && onDeleteCurrentFolder ? (
        <Button variant="outline" size="sm" onClick={onDeleteCurrentFolder}>
          Delete folder
        </Button>
      ) : null}
    </div>
  );
}
